// Import package components
import { createContext, useState } from "react";

import ChatbotService from "../services/chatbot.service";

export const ChatbotContext = createContext();

export const ChatbotProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [currentCompose, setCurrentCompose] = useState({});
  const [faqs, setFaqs] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [unansweredQuestions, setUnansweredQuestions] = useState([]);
  const [total, setTotal] = useState(0);

  const contextChatbot = {
    loading,
    currentCompose,
    faqs,
    templates,
    unansweredQuestions,
    total,
    setLoading,
    setCurrentCompose,

    compose: async (account_id, user_id, question) => {
      setLoading(true);
      try {
        let res = await ChatbotService.composeLog(
          account_id,
          user_id,
          question,
        );
        setLoading(false);
        console.log(res);
        setCurrentCompose(res?.data);
        return res.data;
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    },

    // FAQ management
    listFaqs: async (
      search = "",
      sort_by = "updated_at",
      sort_order = "desc",
      page = 0,
      per_page = 20,
    ) => {
      try {
        const response = await ChatbotService.listFaqs(
          search,
          sort_by,
          sort_order,
          page,
          per_page,
        );
        setFaqs(response.data.paginated || []);
        setTotal(response.data.total || 0);
        return response.data;
      } catch (error) {
        console.error("Error listing FAQs:", error);
        throw error;
      }
    },

    listTemplates: async () => {
      try {
        const response = await ChatbotService.listTemplates();
        setTemplates(response.data || []);

        return response.data;
      } catch (error) {
        throw error;
      }
    },

    createFaq: async (faq) => {
      try {
        const response = await ChatbotService.createFaq(faq);
        return response.data;
      } catch (error) {
        console.error("Error creating FAQ:", error);
        throw error;
      }
    },

    updateFaq: async (id, faq) => {
      try {
        const response = await ChatbotService.updateFaq(id, faq);
        return response.data;
      } catch (error) {
        console.error("Error updating FAQ:", error);
        throw error;
      }
    },

    deleteFaq: async (id) => {
      try {
        await ChatbotService.deleteFaq(id);
      } catch (error) {
        console.error("Error deleting FAQ:", error);
        throw error;
      }
    },

    removeTemplate: async (id) => {
      try {
        await ChatbotService.removeTemplate(id);
      } catch (error) {
        console.error("Error removing Template:", error);
        throw error;
      }
    },

    // Unanswered questions management
    listUnansweredQuestions: async (
      filter = "unresolved",
      search = "",
      page = 0,
      per_page = 20,
    ) => {
      try {
        const response = await ChatbotService.listUnansweredQuestions(
          filter,
          search,
          page,
          per_page,
        );
        setUnansweredQuestions(response.data.paginated || []);
        setTotal(response.data.total || 0);
        return response.data;
      } catch (error) {
        console.error("Error listing unanswered questions:", error);
        throw error;
      } finally {
      }
    },

    deleteUnansweredQuestion: async (id) => {
      try {
        await ChatbotService.deleteUnansweredQuestion(id);
      } catch (error) {
        console.error("Error deleting unanswered question:", error);
        throw error;
      }
    },

    resolve: async (id, question, answer) => {
      try {
        const response = await ChatbotService.resolve(id, question, answer);
        // Update both FAQs and unanswered questions lists
        return response.data;
      } catch (error) {
        console.error("Error adding to FAQ:", error);
        throw error;
      }
    },
  };

  return (
    <ChatbotContext.Provider value={contextChatbot}>
      {children}
    </ChatbotContext.Provider>
  );
};
